<!-- Success Message -->
<div *ngIf="successMessage"
    class="mb-4 p-[18px] rounded-lg bg-green-50 border border-green-200 text-green-700 flex items-center gap-2 text-sm">

    <span class="material-symbols-outlined text-[20px]">check_circle</span>
    {{ successMessage }}

</div>

<!-- Error Message -->
<div *ngIf="errorMessage"
    class="mb-4 p-[18px] rounded-lg bg-red-50 border border-red-200 text-red-700 flex items-center gap-2 text-sm">

    <span class="material-symbols-outlined text-[20px]">error</span>
    {{ errorMessage }}

</div>

<main class="flex-1 max-w-[1500px] mx-auto w-full px-7 lg:px-12 py-9">

    <!-- TITLE -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mb-5">

        <div>
            <h2 class="text-[22px] font-bold text-slate-900 tracking-tight">
                Language Management
            </h2>

            <p class="text-sm text-slate-500 mt-1">
                Configure website locales and translations.
            </p>
        </div>

        <button (click)="addNew()"
            class="flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-3.5 py-2 rounded-md font-semibold shadow transition-all text-sm">

            <span class="material-symbols-outlined text-[20px]">add</span>
            <span>Add Language</span>

        </button>

    </div>

    <div class="flex border-b border-slate-200 mb-4 gap-5">

        <button (click)="setTab('all')" class="pb-2.5 text-sm font-semibold border-b-2 transition-all"
            [class.text-primary]="activeTab === 'all'" [class.border-primary]="activeTab === 'all'">
            All ({{ languages.length }})
        </button>

        <button (click)="setTab('active')" class="pb-2.5 text-sm font-semibold border-b-2 transition-all"
            [class.text-primary]="activeTab === 'active'" [class.border-primary]="activeTab === 'active'">
            Active ({{ activeCount }})
        </button>

        <button (click)="setTab('inactive')" class="pb-2.5 text-sm font-semibold border-b-2 transition-all"
            [class.text-primary]="activeTab === 'inactive'" [class.border-primary]="activeTab === 'inactive'">
            Inactive ({{ inactiveCount }})
        </button>

    </div>

    <div class="mb-4 max-w-[420px]">
        <input type="text" [(ngModel)]="searchText" placeholder="Search languages"
            class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
    </div>

    <!-- TABLE -->
    <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">

        <div class="overflow-x-auto">

            <table class="w-full text-left border-collapse">

                <thead>
                    <tr class="bg-slate-50 border-b border-slate-200">

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">
                            Language Name
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">
                            Locale Code
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase text-center">
                            Status
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase text-right">
                            Actions
                        </th>

                    </tr>
                </thead>

                <tbody class="divide-y divide-slate-100">

                    <tr *ngFor="let lang of filteredLanguages" class="hover:bg-slate-50 transition-colors">

                        <!-- Language -->
                        <td class="px-3.5 py-2.5">
                            <div class="flex items-center gap-2.5">

                                <img [src]="lang.icon" class="w-8 h-8 rounded-full object-cover border" />

                                <span class="font-semibold text-xs text-slate-900">
                                    {{ lang.name }}
                                </span>

                            </div>
                        </td>

                        <!-- Code -->
                        <td class="px-3.5 py-2.5 font-mono text-xs text-slate-500">
                            {{ lang.code }}
                        </td>

                        <!-- Status -->
                        <td class="px-3.5 py-2.5">

                            <div class="flex justify-center">

                                <label class="relative inline-flex items-center cursor-pointer">

                                    <input type="checkbox" class="sr-only peer" [checked]="lang.isEnabled"
                                        (change)="toggleStatus(lang)">

                                    <div class="w-11 h-6 bg-slate-200 rounded-full peer
                                        peer-checked:after:translate-x-full
                                        after:content-['']
                                        after:absolute
                                        after:top-[2px]
                                        after:left-[2px]
                                        after:bg-white
                                        after:border
                                        after:rounded-full
                                        after:h-5
                                        after:w-5
                                        after:transition-all
                                        peer-checked:bg-green-500">
                                    </div>

                                </label>

                            </div>

                        </td>

                        <!-- Actions -->
                        <td class="px-3.5 py-2.5 text-right">

                            <div class="flex justify-end gap-2">

                                <button class="p-1.5 text-slate-400 hover:text-primary"
                                    (click)="viewData(lang.languageId,'Edit')">
                                    <span class="material-symbols-outlined text-[20px]">edit</span>
                                </button>

                                <button class="p-1.5 text-slate-400 hover:text-red-500"
                                    (click)="viewData(lang.languageId,'Delete')">
                                    <span class="material-symbols-outlined text-[20px]">delete</span>
                                </button>

                            </div>

                        </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- MODAL -->
<div *ngIf="isModalOpen" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

    <div class="bg-white w-[525px] rounded-xl shadow-xl">

        <!-- Header -->
        <div class="px-5 py-3.5 border-b border-slate-200 flex justify-between items-center bg-slate-50">

            <div>
                <h3 class="text-[18px] font-bold text-slate-900 flex items-center gap-2">
                    <span class="material-symbols-outlined text-primary text-[20px]">language</span>
                    Add New Language
                </h3>

                <p class="text-sm text-slate-500 mt-0.5">
                    Define a new localization profile for the portal.
                </p>
            </div>

            <button class="text-slate-400 hover:text-slate-600" (click)="closeModal()">
                <span class="material-symbols-outlined text-[22px]">close</span>
            </button>

        </div>

        <!-- Body -->
        <div class="p-5 space-y-4">

            <form enctype="multipart/form-data" class="space-y-4">

                <div>
                    <label class="block mb-1 text-sm font-semibold text-gray-700">
                        Code
                    </label>

                    <input type="text" [(ngModel)]="code" name="code" required maxlength="10"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        placeholder="Enter language code" />
                </div>

                <div>
                    <label class="block mb-1 text-sm font-semibold text-gray-700">
                        Name
                    </label>

                    <input type="text" [(ngModel)]="name" name="name" required maxlength="100"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        placeholder="Enter language name" />
                </div>

                <div>
                    <label class="block mb-1 text-sm font-semibold text-gray-700">
                        Icon
                    </label>

                    <input type="file" (change)="onFileSelected($event)" class="w-full border border-gray-300 rounded-md p-2.5 text-sm
                        file:mr-3 file:py-1.5 file:px-3.5 file:rounded
                        file:border-0 file:text-sm file:font-semibold
                        file:bg-blue-50 file:text-blue-600 hover:file:bg-blue-100" />
                </div>

                <div>

                    <label class="block mb-1 text-sm font-semibold text-gray-700">
                        Is Enable
                    </label>

                    <label class="inline-flex items-center cursor-pointer">

                        <input type="checkbox" (click)="switchEnable()" class="sr-only peer" [(ngModel)]="isEnabled"
                            name="isEnabled">

                        <div class="w-11 h-6 bg-gray-200 rounded-full
peer peer-checked:bg-green-500
relative
after:content-['']
after:absolute
after:top-[2px]
after:left-[2px]
after:bg-white
after:border
after:rounded-full
after:h-5
after:w-5
after:transition-all
peer-checked:after:translate-x-full">
                        </div>

                    </label>

                </div>

            </form>

        </div>

        <!-- Footer -->
        <div class="px-5 py-3.5 bg-slate-50 flex justify-end gap-3 border-t border-slate-200">

            <button (click)="save()" *ngIf="isEnableSave" class="btn-primary">
                <span class="material-symbols-outlined text-[18px]">check_circle</span>
                Create
            </button>

            <button (click)="update()" *ngIf="isEnableUpdate" class="btn-warning">
                <span class="material-symbols-outlined text-[18px]">warning</span>
                Update
            </button>

            <button (click)="delete()" *ngIf="isEnableDelete" class="btn-danger">
                <span class="material-symbols-outlined text-[18px]">delete</span>
                Delete
            </button>

        </div>

    </div>
</div>